import { PdpProgressReportDTO } from './../../types/models/index'

export function pdpProgressReportMap(
  items: PdpProgressReportDTO[],
): PdpProgressReportDTO[] {
  const currentDate = new Date()

  return items
    .sort(
      (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    )
    .map((item) => {
      const itemDate = new Date(item.createdAt)

      if (itemDate < currentDate) {
        return { ...item, status: 'passed' }
      } else {
        return { ...item, status: 'normal' }
      }
    })
}
